import useResponsive from 'src/hooks/useResponsive';
import { BasicList } from './basic-list';
import { BasicTable } from './basic-table';

export const Rows = ({
  columns,
  data,
  enableGlobalFilter,
  enableColumnFilter,
  multiSelect = false,
  singleSelect = false,
  onRowSelected = () => {},
  onRowsSelected = () => {},
}) => {
  const renderTable = useResponsive('up', 'lg');

  return renderTable ? (
    <BasicTable
      columns={columns}
      data={data}
      enableColumnFilter={enableColumnFilter}
      enableGlobalFilter={enableGlobalFilter}
      multiSelect={multiSelect}
      singleSelect={singleSelect}
      onRowSelected={onRowSelected}
      onRowsSelected={onRowsSelected}
    />
  ) : (
    <BasicList
      columns={columns}
      data={data}
      enableColumnFilter={enableColumnFilter}
      enableGlobalFilter={enableGlobalFilter}
      multiSelect={multiSelect}
      singleSelect={singleSelect}
      onRowSelected={onRowSelected}
      onRowsSelected={onRowsSelected}
    />
  );
};
